/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line



document.addEventListener('change', (e) => {
  const input = e.target;
  if (!input.matches('.radio__input[data-single-option-selector], .swatch__input[data-single-option-selector]')) return;

  const fieldset = input.closest('fieldset');
  if (!fieldset) return;

  const legendSelected = fieldset.querySelector('.radio__legend__selected[data-option-selected]');
  if (!legendSelected) return;

  legendSelected.textContent = input.value;
});



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();




